import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import PageSelector from "./PageSelector";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PageSelector />
  </React.StrictMode>
);
